// The app's instance of api-auth (see api-auth.js): the current Firebase user,
// and the backend host from URLs.js.
import firebase from 'firebase/app';
import 'firebase/auth';
import { BACKEND_API_HOST } from '@/lib/URLs';
import { makeApiAuth } from './api-auth';

const apiAuth = makeApiAuth({
    getCurrentUser: () => firebase.auth().currentUser,
    apiHost: BACKEND_API_HOST
});

export const apiAuthHeaders = apiAuth.apiAuthHeaders;
export const installApiAuth = apiAuth.installApiAuth;


// WEBPACK FOOTER //
// ./src/lib/api-auth-client.js